import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  input,
  signal,
} from '@angular/core';
import { UtilsService } from '@geekeno/ngx-website/services';

@Component({
  selector: 'app-lazy-video',
  imports: [],
  templateUrl: './lazy-video.component.html',
  styleUrl: './lazy-video.component.scss',
})
export class LazyVideoComponent implements AfterViewInit {
  private utils = inject(UtilsService);

  autoplay = input(false);
  controls = input(false);
  controlslist = input<'nodownload' | 'nofullscreen' | 'noremoteplayback'>();
  height = input.required<number>();
  loop = input(false);
  muted = input(false);
  playsinline = input<true | null>(null);
  poster = input.required<string>();
  src = input.required<string>();
  width = input.required<number>();
  protected loaded = signal(false);
  private elementRef = inject(ElementRef);
  class = signal<any | null>(null);

  ngAfterViewInit() {
    if (this.utils.isPlatformBrowser) {
      const lazyVideoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            lazyVideoObserver.unobserve(this.elementRef.nativeElement);
            this.loaded.set(true);
          }
        });
      });

      lazyVideoObserver.observe(this.elementRef.nativeElement);
    }
  }
}
